export default __webpack_public_path__ + "c50b2631ea05b0491a8038bcb09085ec.png";